<div *ngIf="shouldShowCTA()">
  <div class="query-table-cta" *ngIf="notifierName === 'airbrake-ruby'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">Monitor background jobs.</h3>
      <p>
        Find out which jobs are slowing down your app with Background Job
        Tracking. Just update the
        <a href="https://rubygems.org/gems/airbrake" target="_blank"
          >airbrake gem to 10.0.0 or higher</a
        >.
      </p>
    </div>
    <div class="query-table-cta__info">
      <pre>
gem 'airbrake'
bundle update airbrake airbrake-ruby</pre
      >
    </div>
  </div>
  <div class="query-table-cta" *ngIf="notifierName === 'gobrake'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">Monitor background jobs.</h3>
      <p>
        Find out which jobs are slowing down your app with Background Job
        Tracking. First, update the
        <a href="https://github.com/airbrake/gobrake/releases" target="_blank"
          >gobrake package to v4.0.0 or higher</a
        >.
      </p>
      <p>
        Next, follow our example, which demonstrates how to send jobs (queues):
        <a href="https://github.com/airbrake/gobrake#sending-queue-stats">
          https://github.com/airbrake/gobrake#sending-queue-stats
        </a>
      </p>
    </div>
    <div class="query-table-cta__info">
      <pre>go get github.com/airbrake/gobrake/v5</pre>
    </div>
  </div>
  <div class="query-table-cta" *ngIf="notifierName === 'pybrake'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">Monitor background jobs.</h3>
      <p>
        Find out which jobs are slowing down your app with Background Job
        Tracking. First, update the
        <a href="https://pypi.org/project/pybrake/" target="_blank"
          >python package to v0.4.0 or higher</a
        >.
      </p>
      <p>
        Next, follow our example, which demonstrates how to send jobs (queues):
        <a href="https://github.com/airbrake/pybrake#sending-queue-stats">
          https://github.com/airbrake/pybrake#sending-queue-stats
        </a>
      </p>

      <p>
        If you happen to use Celery, no further configuration is needed, the
        feature will work out-of-box.
      </p>
    </div>
    <div class="query-table-cta__info">
      <pre>pip install -U pybrake</pre>
    </div>
  </div>
</div>

<div class="query-table-cta" *ngIf="!isSupportedNotifier()">
  <div class="query-table-cta__desc">
    <h3 class="query-table-cta__title">Feature unsupported.</h3>
    <p>
      Your notifier currently doesn't support
      <a
        href="https://docs.airbrake.io/docs/overview/apm/#background-job-monitoring"
      >
        Background Job Tracking </a
      >. If you are interested in the feature, please contact our support at
      support@airbrake.io. Notifiers that support Background Job Tracking
      include:
    </p>
    <ul>
      <li>
        <a href="https://github.com/airbrake/airbrake-ruby">airbrake-ruby</a>
      </li>
      <li>
        <a href="https://github.com/airbrake/gobrake">gobrake</a>
      </li>
      <li>
        <a href="https://github.com/airbrake/pybrake">pybrake</a>
      </li>
      <li>
        <a
          href="https://github.com/airbrake/airbrake-js/blob/master/packages/browser"
          >airbrake-js/browser</a
        >
      </li>
      <li>
        <a
          href="https://github.com/airbrake/airbrake-js/blob/master/packages/node"
          >airbrake-js/node</a
        >
      </li>
    </ul>
  </div>
</div>

<ng-container *ngIf="!shouldShowCTA() && isSupportedNotifier()">
  <div class="top-right-pagination">
    <div class="paginate float-md-right">
      <div class="query-counter" *ngIf="totalQueues > 0">
        {{ totalQueues }} {{ totalQueues | pluralize: "Job":"Jobs" }}, Page
        {{ queuePage }} of {{ totalPages }}
      </div>
      <div class="btn-group">
        <button
          class="btn"
          uiSref="project-performance"
          [uiParams]="{ queuePage: queuePage - 1 }"
          [disabled]="queuePage === 1 || totalPages === 0"
          type="button"
        >
          <i class="glyphicon glyphicon-angle-left"></i>
        </button>
        <button
          class="btn"
          uiSref="project-performance"
          [uiParams]="{ queuePage: queuePage + 1 }"
          [disabled]="queuePage >= totalPages"
          type="button"
        >
          <i class="glyphicon glyphicon-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="content-mask" *ngIf="loading">
    <ab-spinner></ab-spinner>
  </div>
  <div class="ab-table-wrap">
    <div class="ab-table">
      <div class="ab-table__row-grid ab-table__row-grid--6-columns">
        <div class="ab-table__header"></div>
        <div class="ab-table__header ab-table__header--left-border">Jobs</div>
        <div class="ab-table__header"></div>
        <div class="ab-table__header"></div>
        <div class="ab-table__header ab-table__header--left-border">
          Run duration (percentile)
        </div>
      </div>
    </div>
    <div class="ab-table">
      <div class="ab-table__row-grid ab-table__row-grid--6-columns">
        <div class="ab-table__header">
          <a class="th-link" (click)="sortBy('queue')">
            Job name<i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'queue'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            >
            </i>
          </a>
          <input
            class="color--grey-400"
            type="text"
            placeholder="Filter jobs"
            [disabled]="loading"
            [(ngModel)]="search"
            (ngModelChange)="debounceSearchQueue()"
          />
        </div>
        <div class="ab-table__header ab-table__header--left-border">
          <a class="th-link" (click)="sortBy('stat.count')">
            Started
            <i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'stat.count'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            >
            </i>
          </a>
        </div>
        <div class="ab-table__header">
          <a class="th-link" (click)="sortBy('error_count')">
            Failed
            <i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'error_count'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            >
            </i>
          </a>
        </div>
        <div class="ab-table__header">
          <a class="th-link" (click)="sortBy('failure_rate')">
            Failure rate
            <i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'failure_rate'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            >
            </i>
          </a>
        </div>
        <div class="ab-table__header ab-table__header--left-border">
          <a class="th-link" (click)="sortBy('stat.p50')">
            50th
            <i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'stat.p50'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            >
            </i>
          </a>
        </div>
        <div class="ab-table__header">
          <a class="th-link" (click)="sortBy('stat.p95')">
            95th
            <i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'stat.p95'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            >
            </i>
          </a>
        </div>
      </div>
    </div>
    <div class="ab-table">
      <div
        class="ab-table__row-grid ab-table__row-grid--6-columns"
        *ngFor="let queue of queues; trackBy: trackBy"
      >
        <div class="ab-table__cell">
          <ab-env-label
            [env]="queue.environment"
            [truncate]="true"
          ></ab-env-label
          >&nbsp;
          {{ queue.queue }}
        </div>
        <div class="ab-table__cell">{{ queue.stat.count | numberToHuman }}</div>
        <div class="ab-table__cell">
          <a
            *ngIf="queue.errorCount > 0"
            uiSref="project-errors"
            [uiParams]="{
              projectId: project.id,
              filters: {
                'context.action': queue.queue,
                resolved: 'any',
                environment: queue.environment
              }
            }"
          >
            {{ queue.errorCount | numberToHuman }}
          </a>
          <span *ngIf="queue.errorCount === 0">{{
            queue.errorCount | numberToHuman
          }}</span>
        </div>
        <div class="ab-table__cell">
          {{ queue.failureRate * 100 | rateFormat }}%
        </div>
        <div class="ab-table__cell">
          <ab-duration-format
            [milliseconds]="queue.stat.p50"
          ></ab-duration-format>
        </div>
        <div class="ab-table__cell">
          <ab-duration-format
            [milliseconds]="queue.stat.p95"
          ></ab-duration-format>
        </div>
      </div>
    </div>
  </div>
  <div class="blankslate" *ngIf="queues && queues.length === 0">
    <p class="blankslate__text">No data for the chosen time period</p>
    <img
      class="blankslate__image"
      src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/blankslate.svg"
    />
  </div>
</ng-container>
